var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCeasefirLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1481.83 291.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m136.15,127.76c-12.69,22.15-35.7,31.19-60.44,31.19-10.11,0-20.43-1.29-29.9-4.95C15.06,141.95,0,110.77,0,78.94,0,32.48,28.61,0,76.14,0c26.89,0,53.77,12.26,62.8,39.15,1.08,3.44,2.15,6.67,2.58,10.32l-34.2,2.37c-.65-2.8-1.94-5.38-3.22-7.96-6.02-10.75-16.56-15.27-28.39-15.27-28.82,0-38.93,24.95-38.93,50.11,0,15.7,2.58,32.69,15.49,43.45,6.67,5.38,14.84,8.17,23.45,8.17,16.13,0,32.26-10.75,32.48-27.96l35.49,2.36c-.86,7.96-3.44,15.92-7.53,23.01Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.65,155.5V3.66h110.55v27.96h-76.57v30.33h71.19v27.31h-71.19v38.5h78.07v27.75h-112.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.12,155.5l-9.89-32.26h-48.61l-9.68,32.26h-38.07L326.49,3.66h38.93l53.98,151.85h-38.29Zm-34.84-118.51l-15.7,58.5h32.26l-16.56-58.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.31,158.95c-35.49,0-63.02-12.69-64.74-51.62l34.2-1.94c.22,4.3,1.08,9.89,3.66,13.55,6.24,9.03,18.5,11.4,28.82,11.4,11.62,0,27.1-3.01,27.1-17.64,0-26.24-61.73-12.26-82.16-43.88-4.73-7.1-6.67-15.05-6.67-23.44,0-34.2,30.76-45.38,59.79-45.38,33.34,0,58.29,12.26,61.73,48.18l-33.77,2.58c-.65-4.09-.86-7.74-2.8-11.4-5.16-9.89-16.56-11.83-26.67-11.83s-23.87,2.58-23.87,15.49c0,28.61,89.47,4.95,89.47,67.32,0,37.21-32.48,48.61-64.09,48.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.48,155.5V3.66h110.55v27.96h-76.57v30.33h71.19v27.31h-71.19v38.5h78.07v27.75h-112.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m737.94,31.83v32.69h67.97v27.32h-67.97v63.66h-34.2V3.66h111.63v28.18h-77.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m829.56,155.5V3.66h34.2v151.85h-34.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.4,155.5c-6.67-9.25-7.74-19.36-9.25-30.33-1.29-9.25-2.15-19.57-11.83-23.87-4.3-1.94-13.98-1.72-18.71-1.72h-16.99v55.92h-34.2V3.66c17.85,0,35.7-.21,53.56-.21,18.93,0,43.66-1.29,57,14.84,6.45,7.74,9.03,16.99,9.03,27.1,0,17.64-8.39,33.12-26.67,37.21,16.13,3.66,19.36,18.5,21.51,32.48,1.51,9.25,2.58,18.07,5.59,26.88,1.72,4.95,3.66,9.46,6.88,13.55h-35.92Zm-29.9-123.03h-26.89v39.58h17.85c15.92,0,33.98-.21,33.98-21.08,0-15.92-11.83-18.5-24.95-18.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1027.01,155.5V3.66h110.55v27.96h-76.57v30.33h71.19v27.31h-71.19v38.5h78.07v27.75h-112.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.95,268.62c-19.41,0-28.22-14.29-28.22-32.15s9.29-31.91,28.45-31.91c14.05,0,23.57,6.55,25.6,20.96l-11.07,1.67c-.95-8.33-6.31-13.69-14.76-13.69-12.86,0-16.91,12.02-16.91,22.98s3.93,22.98,17.26,22.98c9.41,0,14.76-6.31,15.72-15.12l10.95,1.07c-2.5,15.48-11.43,23.22-27.03,23.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.82,239.45h-44.77v.95c0,7.14,3.69,15.12,10.48,17.98,2.26.95,5.24,1.31,7.74,1.31,7.98,0,13.45-4.17,15-12.26l11.19.83c-2.26,13.93-13.33,20.36-26.79,20.36-4.05,0-8.33-.36-12.14-1.9-12.03-4.76-16.79-17.74-16.79-29.88,0-17.62,10.12-32.26,28.81-32.26s27.38,13.93,27.38,31.55c0,1.07,0,2.26-.12,3.33Zm-26.91-25.48c-10.71,0-16.19,6.79-17.86,16.67h33.46c-.48-9.17-5.72-16.67-15.6-16.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.52,267.43v-30c0-4.29.36-13.93-1.55-17.62-.83-1.67-1.9-2.74-3.45-3.81-1.9-1.43-4.52-1.91-6.79-1.91-8.69,0-14.76,5.6-16.31,14.05-.48,2.26-.48,4.64-.48,7.02v32.26h-10.95v-61.67h10.72v7.98c4.29-5.95,11.31-8.93,18.45-8.93,15.36,0,21.43,8.57,21.43,22.86v39.77h-11.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.9,267.91c-10.72,0-15.36-4.52-15.36-15,0-1.43.12-2.98.12-4.41v-33.69h-10.24v-9.05h10.24v-18.45h10.83v18.45h11.07v9.05h-11.07v32.74c0,5.71-.36,11.19,7.02,11.19,1.55,0,3.45,0,5-.48v8.81c-2.5.24-5,.83-7.62.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.84,216c-3.69,0-7.62,1.19-10.6,3.45-7.74,5.95-7.02,15.6-7.02,24.41v23.57h-10.71v-61.67h10.24v10.48c3.21-7.14,9.17-10.95,16.91-10.95,1.55,0,3.21.24,4.76.48v10.48c-1.19-.12-2.38-.24-3.57-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.96,239.45h-44.77v.95c0,7.14,3.69,15.12,10.48,17.98,2.26.95,5.24,1.31,7.74,1.31,7.98,0,13.45-4.17,15-12.26l11.19.83c-2.26,13.93-13.33,20.36-26.79,20.36-4.05,0-8.33-.36-12.14-1.9-12.03-4.76-16.79-17.74-16.79-29.88,0-17.62,10.12-32.26,28.81-32.26s27.38,13.93,27.38,31.55c0,1.07,0,2.26-.12,3.33Zm-26.91-25.48c-10.71,0-16.19,6.79-17.86,16.67h33.46c-.48-9.17-5.71-16.67-15.6-16.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.02,214.81v52.62h-10.83v-52.62h-10v-9.05h10v-4.64c0-12.26,5.24-17.98,18.1-17.98,1.79,0,3.57.24,5.36.36v9.28c-1.31-.12-2.62-.12-3.93-.12-1.07,0-3.69,0-4.52.24-4.88,1.43-4.17,6.19-4.17,10.24v2.62h12.62v9.05h-12.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.68,268.62c-20,0-28.81-13.21-28.81-31.67s9.88-32.38,29.65-32.38,29.05,13.81,29.05,32.15c0,19.29-10.36,31.91-29.88,31.91Zm.36-55c-13.81,0-18.1,11.43-18.1,23.46s4.64,22.86,18.45,22.86,17.98-11.31,17.98-23.22-4.88-23.1-18.33-23.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.95,216c-3.69,0-7.62,1.19-10.6,3.45-7.74,5.95-7.02,15.6-7.02,24.41v23.57h-10.72v-61.67h10.24v10.48c3.22-7.14,9.17-10.95,16.91-10.95,1.55,0,3.22.24,4.76.48v10.48c-1.19-.12-2.38-.24-3.57-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.92,268.62c-19.41,0-28.22-14.29-28.22-32.15s9.29-31.91,28.45-31.91c14.05,0,23.57,6.55,25.6,20.96l-11.07,1.67c-.95-8.33-6.31-13.69-14.76-13.69-12.86,0-16.91,12.02-16.91,22.98s3.93,22.98,17.26,22.98c9.41,0,14.76-6.31,15.72-15.12l10.95,1.07c-2.5,15.48-11.43,23.22-27.03,23.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.57,195.64v-12.26h10.83v12.26h-10.83Zm0,71.79v-61.67h10.83v61.67h-10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623.31,267.43h-10l-21.67-61.67h11.79l15.12,46.55,15.48-46.55h11.67l-22.38,61.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650.82,195.64v-12.26h10.83v12.26h-10.83Zm0,71.79v-61.67h10.83v61.67h-10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.56,267.43v-84.05h10.83v84.05h-10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m696.3,195.64v-12.26h10.83v12.26h-10.83Zm0,71.79v-61.67h10.83v61.67h-10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m765.83,267.43c-5.83,0-9.64-1.19-10.12-7.74-5.36,5.95-11.67,8.93-19.76,8.93-12.02,0-20.83-6.31-20.83-19.05,0-13.93,11.19-16.31,22.38-18.34,3.21-.59,6.55-1.19,9.76-1.9,1.67-.36,6.43-1.07,7.38-2.5.71-.95.83-2.14.83-3.22,0-8.45-6.67-10.36-13.81-10.36-7.86,0-13.33,3.21-13.33,11.67h-11.07c0-1.9.36-4.05.95-5.95,3.33-11.55,13.93-14.41,24.64-14.41,7.98,0,16.79,1.79,20.72,9.53,2.02,4.05,1.9,9.52,1.9,13.93v23.81c0,5.24.24,7.5,6.19,7.62v7.98h-5.83Zm-10.48-31.91c-5.12,1.79-10.36,2.86-15.6,3.93-2.38.48-5,.83-7.26,1.79-3.69,1.67-6.07,4.53-6.07,8.69,0,6.79,5.95,9.88,12.03,9.88,2.98,0,6.67-.95,9.17-2.5,6.55-4.17,7.74-10,7.74-17.26v-4.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m818.57,267.43v-30c0-4.29.36-13.93-1.55-17.62-.83-1.67-1.91-2.74-3.45-3.81-1.9-1.43-4.52-1.91-6.79-1.91-8.69,0-14.76,5.6-16.31,14.05-.48,2.26-.48,4.64-.48,7.02v32.26h-10.95v-61.67h10.71v7.98c4.29-5.95,11.31-8.93,18.45-8.93,15.36,0,21.43,8.57,21.43,22.86v39.77h-11.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m900.01,216c-3.69,0-7.62,1.19-10.6,3.45-7.74,5.95-7.02,15.6-7.02,24.41v23.57h-10.71v-61.67h10.24v10.48c3.22-7.14,9.17-10.95,16.91-10.95,1.55,0,3.21.24,4.76.48v10.48c-1.19-.12-2.38-.24-3.57-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.3,195.64v-12.26h10.83v12.26h-10.83Zm0,71.79v-61.67h10.83v61.67h-10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m956.2,289.1c-14.05,0-23.57-5.24-24.41-20.12h11.07c0,8.45,6.67,11.19,14.05,11.19,15.95,0,15.48-10.48,15.48-22.98-3.81,5.71-11.67,8.33-18.22,8.33-17.26,0-25.24-13.69-25.24-29.53v-.48c0-16.79,8.93-30.6,26.79-30.6,7.03,0,13.22,2.14,17.14,8.33v-7.5h9.76v56.31c0,19.29-6.67,27.03-26.43,27.03Zm15.84-61.2c-1.43-8.1-6.79-13.57-15.24-13.57-12.38,0-16.67,10.6-16.67,21.19s4.05,20.6,16.19,20.6,16.19-10,16.19-20.48c0-2.5,0-5.24-.47-7.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1034.07,267.43v-36.31c0-8.45-.95-16.55-11.79-16.55-7.5,0-14.05,4.05-16.19,11.43-.83,2.86-.71,5.83-.71,8.69v32.74h-10.95v-84.05h10.95v29.41c5.24-5.95,11.9-7.98,19.53-7.98,4.64,0,9.29,1.07,12.98,3.93,7.14,5.48,7.14,13.1,7.14,21.31v37.38h-10.95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1076.34,267.91c-10.71,0-15.36-4.52-15.36-15,0-1.43.12-2.98.12-4.41v-33.69h-10.24v-9.05h10.24v-18.45h10.83v18.45h11.07v9.05h-11.07v32.74c0,5.71-.36,11.19,7.02,11.19,1.55,0,3.45,0,5-.48v8.81c-2.5.24-5,.83-7.62.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1112.18,268.86c-14.88,0-23.69-6.55-24.41-21.79l10.24-1.19c0,9.29,5.6,14.53,14.64,14.53,5.83,0,12.74-2.38,12.74-9.29,0-14.17-34.76-6.67-34.76-28.81,0-12.38,10.6-17.62,21.67-17.62,12.62,0,22.98,6.19,22.98,19.76l-9.76,1.19c-.6-8.69-4.17-12.62-13.33-12.62-5.24,0-10.83,2.03-10.83,8.1,0,7.14,7.98,8.1,13.33,9.64,10.59,3.1,21.55,6.43,21.55,19.64s-12.26,18.46-24.05,18.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1191.59,
    y: 2.55,
    width: 97.01,
    height: 289.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1384.82,
    y: 2.31,
    width: 97.01,
    height: 289.24,
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeasefirLogoWhite);
export default __webpack_public_path__ + "static/media/Ceasefir_logoWHITE.d5b3fe36466e344755f1b618aabdd3dc.svg";
export { ForwardRef as ReactComponent };